import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
let MemoryCacheService = /*#__PURE__*/(() => {
  class MemoryCacheService {
    constructor() {
      this.store = {};
    }
    has(key) {
      return this.store.hasOwnProperty(key);
    }
    clean() {
      this.store = {};
    }
    remove(key) {
      delete this.store[key];
    }
    put(key, value) {
      this.store[key] = value;
    }
    get(key, defaultValue = null) {
      if (this.has(key)) {
        return this.store[key];
      }
      return defaultValue;
    }
    static {
      this.ɵfac = function MemoryCacheService_Factory(t) {
        return new (t || MemoryCacheService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: MemoryCacheService,
        factory: MemoryCacheService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return MemoryCacheService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of ng-lib-memory-cache
 */

/**
 * Generated bundle index. Do not edit.
 */

export { MemoryCacheService };
